import { api } from "@/api";
import {
  UpsertSportSuspensionsParams,
  SportSuspensionsEditorResponse,
} from "@/types/ApiResponses/Sport";

export const upsertSportsSuspensions = async (
  data: UpsertSportSuspensionsParams
): Promise<SportSuspensionsEditorResponse> => {
  const res = await api.client.post(`/sports-new/suspensions`, data);
  return res.data;
};
